<template>
  <div class="list-item">
    <div class="d-flex flex-column flex-grow-1 p-3 text-truncate">
      <div
        class="text-truncate semi-bold"
        :class="{ 'cursor-pointer': $listeners.select }"
        @click="onSelectHandler"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="item-platform d-flex p-3">
      <img
        :src="materialPlatforms[item.type]?.icon"
        :alt="item.title"
        width="20"
      />
      <div class="text-truncate">
        {{ materialPlatforms[item?.type]?.label }}
      </div>
    </div>
    <div class="d-flex justify-content-end p-3 source-materials-actions">
      <eg-button
        v-if="showDeleteButton"
        type="secondary"
        icon="delete"
        size="small"
        @click="onDeleteHandler"
      />
      <eg-button
        type="secondary"
        icon="pen-edit"
        size="small"
        @click="onEditHandler"
      />
      <slot name="extra-actions" />
    </div>
  </div>
</template>

<script>
import { deleteSourceMaterials } from "@/api";
import CreateEditSourceMaterialModal from "@/components/source-materials/create_edit_source_material_modal.vue";

export default {
  name: "SourceMaterialItem",
  inject: ["materialPlatforms"],

  props: {
    item: {
      type: Object,
      required: true,
    },
    showDeleteButton: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    async onDeleteHandler() {
      try {
        const value = await this.$showDeleteConfirmationModal();
        if (value) {
          await deleteSourceMaterials(this.item.id);
          this.$emit("deleted", this.item.id);
        }
      } catch (error) {
        this.$showToastError(error);
      }
    },
    onEditHandler() {
      this.$egModal.show("create-edit-source-material-modal", {
        component: CreateEditSourceMaterialModal,
        props: {
          sourceMaterialId: this.item.id,
        },
        on: {
          onSave: () => {
            this.$emit("saved");
          },
        },
      });
    },
    onSelectHandler() {
      if (!this.$listeners.select) return;

      this.$emit("select", this.item);
    },
  },
};
</script>

<style scoped>
.list-item {
  display: flex;
  gap: 8px;
  align-items: center;
  background-color: var(--color-surface-neutral-default);
  border: 1px solid var(--color-stroke-neutral-default);
  border-radius: var(--radius-rd-300);
}

.item-platform {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 150px;
  min-width: 150px;
}
.source-materials-actions {
  gap: 0.75rem;
}
</style>
